/* eslint-disable no-undefined */
import React from 'react'
import useSearch from '../../../context/search/useSearch';
import getRoute from '../../../../scripts/utils/getRoute'

interface ISearchResultsSuggestionsComponent {
  dataSet: DOMStringMap
}

const SearchResultsSuggestions: React.FC<ISearchResultsSuggestionsComponent> = ({ dataSet }): JSX.Element => {

  const {
    langTitle
  } = dataSet

  const {quickSearchResultsSuggestions } = useSearch()

  // const handleOnClickSuggestion = (index) => eventHandlers.handleSearchSuggestionSelected(index)

  if (quickSearchResultsSuggestions && !quickSearchResultsSuggestions.length) return null

  const renderSuggestion = (highlightedOrValue: string) => {
    if (!highlightedOrValue) return null;
    const parts: React.ReactNode[] = [];
    const regex = /\{([^}]*)\}|([^{}]+)/g;
    let match;
    let i = 0;
    while ((match = regex.exec(highlightedOrValue)) !== null) {
      if (match[1] !== undefined) {
        // Inside braces - base term (normal weight)
        parts.push(<span key={`n-${i++}`}>{match[1]}</span>);
      } else if (match[2] !== undefined) {
        // Outside braces - suggested addition (bold)
        parts.push(<strong key={`b-${i++}`}>{match[2]}</strong>);
      }
    }
    return parts;
  };

  return (
    <div className={`search__results search__results--list search__results--suggestions ${(quickSearchResultsSuggestions && quickSearchResultsSuggestions.length) && 'search__results--loaded'}`}>
      {(quickSearchResultsSuggestions && quickSearchResultsSuggestions.length) && <>
        <div className={'search__results-title search__results-title--suggestions subheading'}>{langTitle}</div>
        <div className={'search__results-list search__results-list--suggestions'}>
          <ul>
            {quickSearchResultsSuggestions.map((suggestion, index) => {
              return (
                <li className={'search__results-item search__results-item--suggestions'} key={index}>
                  <a href={`${getRoute()}search?q=${encodeURIComponent(suggestion.query)}&phrase_suggest=1`}>
                    {renderSuggestion((suggestion as any).highlighted || suggestion.value)}
                  </a>
                </li>
              )
            })}
          </ul>
        </div>
      </>}
    </div>
  )
}

export default SearchResultsSuggestions